import { useRef } from "react";
import { useOrbit } from "../../hooks/useOrbit";
import "./TechOrbit.css";

const TechOrbit = ({ chips, periodSeconds = 180 }) => {
  const orbitRef = useRef(null);
  useOrbit(orbitRef, ".hero__chip--orbit", periodSeconds);

  return (
    <div className="hero__orbit" ref={orbitRef}>
      {chips.map((c, i) => (
        <div
          key={c.label}
          className="hero__chip hero__chip--orbit"
          style={{ "--i": i, "--n": chips.length }}
        >
          <i className={c.icon} /> {c.label}
        </div>
      ))}
    </div>
  );
};

export default TechOrbit;
